import { baseURL } from "./ServiceUtil";
import fetchData from "../utils/getAllPaginated";

// export const getRegions = (): Observable<any> =>
//   customAjax(`${baseURL}/regions`);

export const getRegions = (): Promise<any> => {
  return fetchData(`${baseURL}/regions`);
};
